import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance";

// Define an async thunk to fetch data from the API

export const fetchCommunityData = createAsyncThunk(
  "community/fetchCommunityData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/community/");
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchCommunityDocName = createAsyncThunk(
  "community/fetchCommunityDocName",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        "/community/community_doc_name_list/"
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchCommunityByCommunityName = createAsyncThunk(
  "community/fetchCommunityDataByName",
  async ({ communityName, city }, { rejectWithValue }) => {
    try {
      // Build the query string dynamically
      const queryParams = new URLSearchParams();

      if (communityName) {
        queryParams.append("community_name", communityName);
      } else {
        console.error("communityName is empty or undefined");
      }

      if (city) {
        queryParams.append("city", city);
      }

      // Log the full query string to debug
      const queryString = queryParams.toString();

      // Make the API request with the query string
      const response = await axiosInstance.get(
        `/community/search/?${queryString}`
      );

      return response.data;
    } catch (error) {
      // Handle errors appropriately
      console.error("API call error:", error.response || error);
      return rejectWithValue(
        error.response ? error.response.data : "An error occurred"
      );
    }
  }
);

export const fetchCommunityByCommunityId = createAsyncThunk(
  "community/fetchCommunityDataById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/community/${id}/`);
      return response.data;
    } catch (error) {
      // Handle errors appropriately
      return rejectWithValue(
        error.response ? error.response.data : "An error occurred"
      );
    }
  }
);

export const createNewCommunity = createAsyncThunk(
  "community/createNewCommunityapi",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/community/", formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const deleteCommunityData = createAsyncThunk(
  "community/deleteCommunityData",
  async (communityId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`/community/${communityId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const createNewCommunityGpt = createAsyncThunk(
  "community/createNewCommunityGpt",
  async (communityData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/community/community_check_or_create/",
        communityData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// export const createNewCommunityGpt = createAsyncThunk(
//   "community/createNewCommunity",
//   async (communityData, { rejectWithValue }) => {
//     try {
//       const response = await axios.post(
//         "https://sdeiaiml.com:8004/community/community_check_or_create/",
//         JSON.stringify(communityData),
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response
//           ? {
//               message: error.response.data.message,
//               status: error.response.status,
//             }
//           : { message: error.message }
//       );
//     }
//   }
// );

export const updateCommunityApi = createAsyncThunk(
  "community/UpdateCommunityApi",
  async ({ formData, communityId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `/community/${communityId}`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const vendorCheckOrCreate = createAsyncThunk(
  "community/vendorCheckOrCreate",
  async (communityCity, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/community/vendor_check_or_create/",
        communityCity
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const healthVendorCheckOrCreate = createAsyncThunk(
  "community/healthVendorCheckOrCreate",
  async (communityCity, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/community/health_vendor_check_or_create/",
        communityCity
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const educationVendorCheckOrCreate = createAsyncThunk(
  "community/educationVendorCheckOrCreate",
  async (communityCity, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/community/education_vendor/",
        communityCity
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const getAllCommunityDataPublic = createAsyncThunk(
  "community/fetchCommunityData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/community/all-community");
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchCommunityDatabyClaimStatus = createAsyncThunk(
  "community/fetchCommunityDatabyClaimStatus",
  async ({ page, page_size, search }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        "/community/all-community-Claim-Status", {
        params: {
          page: page,
          page_size: page_size,
          search: search,
        }
      }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchCommunityDataByUserIdClaimStatus = createAsyncThunk(
  "community/fetchCommunityDataByUserIdClaimStatus",
  async ({ userId, activeTab, page, page_size }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/community/community_claim_status/${userId}?filter=${activeTab}&page=${page}&page_size=${page_size}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


export const deleteCommunityByClaimStatus = createAsyncThunk(
  "community/deleteCommunityByClaimStatus",
  async (Id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`/community/claim/${Id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const getCommunityName = createAsyncThunk(
  "community/getCommunityName",
  async (communityName, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/community/community-search?search=${communityName}`);
      return response.data;
    } catch (error) {
      // Handle errors appropriately
      return rejectWithValue(
        error.response ? error.response.data : "An error occurred"
      );
    }
  }
);

export const fetchCommunityHomeownerData = createAsyncThunk(
  "community/fetchCommunityHomeownerData",
  async ({ id, page, page_size, search }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/community/community-homeowners/${id}`, {
        params: {
          search: search,
          page: page,
          page_size: page_size,
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchCommunityDataByUserId = createAsyncThunk(
  "community/fetchCommunityDataByUserId",
  async ({ userId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/community/communities_by_user/${userId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchCommunityDataWithPagination = createAsyncThunk(
  "community/fetchCommunityData",
  async ({ page, page_size, searchQuery }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/community/all-commuity-pagination", {
        params: {
          page: page,
          page_size: page_size,
          search: searchQuery,
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchRealtorDetails = createAsyncThunk(
  "community/fetchRealtorDetails",
  async ({ community_id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        "/community/realtor-details",
        {
          params: {
            community_id: community_id
          }
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
